const state = {
	showingSlackPupup: false,
	slackPupupTitle: "",
	showingNotificationsPupup: false,
	showingNotificationsPupupSources: [],
	showingNotificationsPupupTitle: "Notifications",
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
	showSlackPupup(state, info) {
		state.showingSlackPupup = true;
		state.slackPupupTitle = !!info && !!info.title ? info.title : "";
	},

	closeSlackPupup(state) {
		state.showingSlackPupup = false;
		state.slackPupupTitle = "";
	},

	showNotificationsPupup(state, info) {
		state.showingNotificationsPupup = true;
		state.showingNotificationsPupupSources = !!info && !!info.sources ? info.sources : [];
		state.showingNotificationsPupupTitle = !!info && !!info.title ? info.title : "Notifications";
	},

	closeNotificationsPupup(state) {
		state.showingNotificationsPupup = false;
		state.showingNotificationsPupupTypes = [];
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
